import React from "react";
import { Box, Stack, Typography, Paper } from "@mui/material";
import { styles } from "./FilterNSearchBar.styles";
import { FilterBarSearch } from "./FilterBarSearch";
import { FilterBarChips } from "./FilterBarChips";

const FilterBar = ({
  searchQuery = "",
  onSearchChange,
  filterLabel = "",
  filters = [],
  selectedFilter = null,
  onFilterChange,
  onClearFilters,
  countLabel = "",
}) => (
  <Box mb={2}>
    {/* Row 1: Search and Count */}
    <Stack direction="row" alignItems="center" spacing={2} mb={1}>
      <Box flex={1} minWidth={220}>
        <FilterBarSearch
          searchQuery={searchQuery}
          onSearchChange={onSearchChange}
        />
      </Box>
      <Box minWidth={120} display="flex" justifyContent="flex-end">
        {countLabel && (
          <Paper elevation={0} sx={styles.countBadge}>
            <Typography variant="body2" color="#374151" fontWeight="500">
              {countLabel}
            </Typography>
          </Paper>
        )}
      </Box>
    </Stack>
    {/* Row 2: Filter Chips Slider */}
    {filters.length > 0 && (
      <FilterBarChips
        filterLabel={filterLabel}
        filters={filters}
        selectedFilter={selectedFilter}
        onFilterChange={onFilterChange}
        onClearFilters={onClearFilters}
        showClear={!!(searchQuery || selectedFilter)}
      />
    )}
  </Box>
);

export default FilterBar;
